export default __webpack_public_path__ + "static/media/doctrine.e6786ae6.svg";